import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '../components/Dashboard/Dashboard.vue'
import AdEdit from '../components/Ads/AdEdit.vue'
import Profile from '../components/Profile/Profile.vue'
import Settings from '../components/Settings/Settings.vue'
import TagSettings from '../components/Settings/TagSettings.vue'
import ManageUsers from '../components/Settings/ManageUsers.vue'
import AdvertiserUser from '../components/Settings/AdvertiserUser.vue'
import Performance from '../components/Performance/Performance.vue'
import Files from '../components/FileExchange/Files.vue'
import config from "../config";
import Credits from '../components/Credits/Credits.vue'
import AutoCampaigns from '../components/AutoCampaign/AutoCampaigns.vue'
import AutoCampaignDetail from '../components/AutoCampaign/AutoCampaignDetail.vue'
import Insights from '../components/Insights/Insights.vue'
import { beforeEach } from '@springbig/sb-components'

Vue.use(Router)

const router = new Router({

  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/ad/:id?',
      name: 'AdEdit',
      component: AdEdit,
      props: true
    },
    {
      path: '/autoconnects',
      name: 'AutoCampaigns',
      component: AutoCampaigns
    },
    {
      path: '/autoconnects/:id',
      name: 'AutoCampaignDetail',
      component: AutoCampaignDetail
    },
    {
      path: '/insights',
      name: 'Insights',
      component: Insights
    },
    {
      path: '/settings/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/settings/manage-users/advertiser-user/:id?',
      name: 'AdvertiserUser',
      component: AdvertiserUser
    },
    {
      path: '/settings/tag-settings',
      name: 'Tag Settings',
      component: TagSettings
    },
    {
      path: '/settings/manage-users',
      name: 'ManageUsers',
      component: ManageUsers
    },
    {
      path: '/performance/:id',
      name: 'Performance',
      component: Performance
    },
    {
      path: '/files',
      name: 'Files',
      component: Files
    },
    {
      path: '/credits',
      name: 'Credits',
      component: Credits
    },
    {
      path: '/admin',
      beforeEnter() {location.href = `${config.redirectUrl}/admin`}
    },
    {
      path: '/retailer',
      beforeEnter() {location.href = `${config.redirectUrl}`}
    },
    {
      path: '/logout',
      beforeEnter() {location.href = `${config.redirectUrl}/sessions/new`}
    }
  ]
})

router.beforeEach(beforeEach)

export default router